module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page) ? _c('div', {
    staticClass: "donor"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v("รายชื่อผู้ร่วมบริจาค "), _c('span', {
    staticClass: "donor-count"
  }, [_vm._v("(" + _vm._s(_vm._f("comma")(_vm.totalDonors)) + " คน)")])]), _vm._v(" "), (_vm.donors.length > 0) ? _c('ul', {
    staticClass: "donor-list"
  }, _vm._l((_vm.donors), function(donor) {
    return _c('li', {
      staticClass: "donor-item"
    }, [_c('div', {
      staticClass: "donor-item-icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "donor-item-user"
    }, [_vm._v(_vm._s(donor.name)), _c('br'), _c('span', {
      staticClass: "donor-item-date"
    }, [_vm._v(_vm._s(donor.date))]), _c('br'), _vm._v(" "), (donor.message) ? _c('span', {
      staticClass: "donor-item-message"
    }, [_vm._v(_vm._s(donor.message))]) : _vm._e()])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.donors.length === 0) ? _c('div', {
    staticClass: "text-center no-donor"
  }, [_vm._v("ยังไม่มีผู้ร่วมบริจาค")]) : _vm._e(), _vm._v(" "), (_vm.showLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.showLoadMore) ? _c('div', {
    staticClass: "w-30 mt-15 mb-20"
  }, [_c('a', {
    staticClass: "btn btn--white btn--sm",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loadMore.apply(null, arguments)
      }
    }
  }, [_vm._v("ดูเพิ่ม")])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22862973","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DonorList.vue
// module id = 1122
// module chunks = 0